// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderDetailStyle {
	padding: 20px 2px;
	display: flex;
	justify-content: space-between;
	flex-direction: column;
	overflow: auto;
	scrollbar-width: none;
	-ms-overflow-style: none;
}

.OrderDetailStyle::-webkit-scrollbar {
	display: none;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Pages/Dashboard/OrganizationDashboard/pdfdetails-mobile.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;CACjB,aAAa;CACb,8BAA8B;CAC9B,sBAAsB;CACtB,cAAc;CACd,qBAAqB;CACrB,wBAAwB;AACzB;;AAEA;CACC,aAAa;AACd","sourcesContent":[".OrderDetailStyle {\n\tpadding: 20px 2px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tflex-direction: column;\n\toverflow: auto;\n\tscrollbar-width: none;\n\t-ms-overflow-style: none;\n}\n\n.OrderDetailStyle::-webkit-scrollbar {\n\tdisplay: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
